import {ServiceTypeOption, ServiceTypesEnum} from '../../api/service/types'

export const DEFAULT_SERVICE_OPTION: ServiceTypeOption = {
  value: ServiceTypesEnum.SERVICES,
  label: 'services',
  icon: 'shoppingCart',
}
